export default class FlowDiagramNode {
    constructor (dto) {
        this.id = null;
        this.width = 200;
        this.x = 0;
        this.y = 10;
        this.level = 0;
        this.type = "operation";
        this.name = null;
        this.approvers =  [{name: ' '}];
        this.color = "#ffffff";
        this.source = "dto";

        if (dto) {
            this.id = dto.StateID;
            this.name = dto.StateName;
            if (dto.IsCurrentState) {
                this.color = '#BBDEFB';
            } else if (dto.TransitionHistory && dto.TransitionHistory.length > 0) {
                this.color = '#C8E6C9';

                this.approvers = [{name: dto.TransitionHistory[0].Date + " - " + dto.TransitionHistory[0].User}];
            }
        }
    }
}
